function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

(function () {
  function initMultiAddCart() {
    const sections = document.querySelectorAll('.multi-add-cart-section');
    if (!sections.length) return;

    sections.forEach((section) => {
      const addToCartBtns = section.querySelectorAll('.bulk-add-to-cart');
      const qtyInputs = section.querySelectorAll('.qty-input');
      const countEls = section.querySelectorAll('.bulk-count');
      const totalEl = section.querySelector('#bulk-total');

      if (!addToCartBtns.length) return;

      /* ---------- RESET ---------- */

      function resetBundle() {
        qtyInputs.forEach((input) => (input.value = 0));
      }

      /* ---------- CALCULATE TOTAL QTY ---------- */

      function calculateOverallQty() {
        let totalQty = 0;

        qtyInputs.forEach((input) => {
          totalQty += parseInt(input.value || 0, 10);
        });

        return totalQty;
      }

      /* ---------- CALCULATE TOTAL PRICE ---------- */

      function calculateOverallTotal() {
        let totalCents = 0;

        qtyInputs.forEach((input) => {
          const price = parseInt(input.dataset.price || 0, 10);
          const qty = parseInt(input.value || 0, 10);

          totalCents += price * qty;
        });

        return totalCents;
      }

      /* ---------- UPDATE UI ---------- */

      function updateBundleUI() {
        const totalQty = calculateOverallQty();
        const totalCents = calculateOverallTotal();

        if (totalEl) {
          totalEl.textContent = `$${(totalCents / 100).toFixed(2)}`;
        }

        countEls.forEach((el) => {
          el.textContent = totalQty;
        });

        addToCartBtns.forEach((btn) => {
          btn.classList.toggle('is-disabled', totalQty === 0);
        });
      }

      /* ---------- PLUS / MINUS BUTTONS ---------- */

      section.addEventListener('click', (e) => {
        const plus = e.target.closest('.qty-plus');
        const minus = e.target.closest('.qty-minus');

        if (plus) {
          const input = plus.closest('.qty-box').querySelector('.qty-input');
          input.value = parseInt(input.value || 0) + 1;
          updateBundleUI();
        }

        if (minus) {
          const input = minus.closest('.qty-box').querySelector('.qty-input');
          input.value = Math.max(0, parseInt(input.value || 0) - 1);
          updateBundleUI();
        }
      });

      section.addEventListener('input', (e) => {
        if (e.target.matches('.qty-input')) {
          updateBundleUI();
        }
      });

      /* ---------- ADD TO CART ---------- */

      document.addEventListener('click', async function (e) {
        const btn = e.target.closest('.bulk-add-to-cart');
        if (!btn) return;

        const section = btn.closest('.multi-add-cart-section');
        if (!section) return;

        const items = [];
        let hasError = false;

        const productItems = [...section.querySelectorAll('.multi-add-cart-item')].filter((item) =>
          item.querySelector('.qty-input')
        );

        for (const item of productItems) {
          const qtyInput = item.querySelector('.qty-input');
          const qty = parseInt(qtyInput.value) || 0;

          const personalizationInput = item.querySelector('.personalization-input');
          const errorEl = item.querySelector('.personalization-error');
          if (errorEl) errorEl.textContent = '';

          const hasPersonalizationField = !!personalizationInput;

          const personalization = personalizationInput?.value.trim() || '';

          if (qty > 0) {
            if (hasPersonalizationField && !personalization) {
              hasError = true;

              if (errorEl) {
                errorEl.textContent = 'Personalization is required.';
              }

              break;
            }

            const itemData = {
              id: qtyInput.dataset.variantId,
              quantity: qty,
            };

            if (hasPersonalizationField && personalization) {
              itemData.properties = {
                ['personalization-message']: personalization,
              };
            }

            items.push(itemData);
          }
        }

        if (hasError) return;

        if (items.length === 0) {
          const errorBoxes = section.querySelectorAll('.bulk-error-message');

          errorBoxes.forEach((errorBox) => {
            if (!errorBox) return;

            let msgEl = errorBox.querySelector('.bulk-error-text');

            if (!msgEl) {
              msgEl = document.createElement('span');
              msgEl.className = 'bulk-error-text';
              errorBox.appendChild(msgEl);
            }

            msgEl.textContent = 'Please select at least one item from the collection.';

            errorBox.style.display = 'flex';

            clearTimeout(errorBox._hideTimer);

            errorBox._hideTimer = setTimeout(() => {
              errorBox.style.display = 'none';
            }, 5000);
          });

          return;
        }

        try {
          btn.classList.add('loading');

          // Ask for the drawer's section HTML so the mini cart can morph in place (same as native ATC).
          const cartSectionId = document.querySelector('cart-items-component')?.dataset.sectionId;

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, ...(cartSectionId ? { sections: [cartSectionId] } : {}) }),
          });

          if (!res.ok) throw new Error('Cart failed');

          // Criteo addToCart dataLayer push
          const responseData = await res.clone().json();
          const addedItems = Array.isArray(responseData.items)
            ? responseData.items
            : [responseData];
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'criteo_add_to_cart',
            criteo_item_array: addedItems.map((item) => ({
              id: item.product_id,
              price: item.price / 100,
              quantity: item.quantity,
            })),
          });
          console.log(
            'bulk criteo_add_to_cart fired:',
            window.dataLayer.filter((e) => e.event === 'criteo_add_to_cart')
          );

          // Stay on the page: refresh the mini cart and let it auto-open, instead of sending shoppers to /cart.
          const { CartAddEvent } = await import('@theme/events');

          document.dispatchEvent(
            new CartAddEvent({}, 'collection-multi-add-cart', {
              source: 'collection-multi-add-cart',
              itemCount: items.reduce((total, item) => total + item.quantity, 0),
              sections: responseData.sections,
            })
          );

          resetBundle();
          updateBundleUI();
        } finally {
          btn.classList.remove('loading');
        }
      });

      /* ---------- INIT ---------- */

      resetBundle();
      updateBundleUI();
    });
  }

  document.addEventListener('DOMContentLoaded', initMultiAddCart);
})();

/* =========================================
   THUMBNAIL + ZOOM + FANCYBOX
========================================= */

document.addEventListener('click', function (e) {
  /* MORE THUMB */

  const moreBtn = e.target.closest('.multi-thumb.more-thumb');

  if (moreBtn) {
    e.preventDefault();
    e.stopPropagation();

    const bundle = moreBtn.closest('.multi-add-cart-left');

    if (!bundle) return;

    const visibleThumbs = bundle.querySelectorAll('.multi-thumb:not(.is-hidden):not(.more-thumb)');

    const startIndex = visibleThumbs.length;

    openBundleFancybox(bundle, startIndex);

    return;
  }

  /* THUMB CLICK */

  const thumb = e.target.closest('.multi-thumb:not(.more-thumb)');

  if (thumb) {
    e.preventDefault();

    const bundle = thumb.closest('.multi-add-cart-left');
    const wrapper = bundle?.querySelector('.multi-image-wrapper');
    const img = thumb.querySelector('img');

    if (!bundle || !wrapper || !img) return;

    const isVimeo = img.dataset.type === 'vimeo';
    const isVideo = img.dataset.type === 'video';

    /* Vimeo */

    if (isVimeo) {
      const videoId = img.dataset.vimeoId;
      const altText = img.alt || 'Product video';

      wrapper.innerHTML = `
       <iframe
      src="https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&playsinline=1&autopause=0"
      title="${altText}"
      aria-describedby="video-transcript-${videoId}"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      class="multi-main-video"
    ></iframe>

    <div id="video-transcript-${videoId}" class="visually-hidden">
      Product video for collection item showing product details, angles, and features.
    </div>

      <div class="multi-image-lens"></div>
    `;
    } else if (isVideo) {
      /* Shopify Video */
      const videoSrc = img.dataset.videoSrc;
      const poster = img.dataset.poster;
      const altText = img.alt || 'Product video';

      if (!videoSrc) return;

      wrapper.innerHTML = `
    <video
      playsinline
      autoplay
      loop
      muted
      controls
      class="multi-main-video js-multi-main-video"
      preload="metadata"
      poster="${poster}"
      aria-label="${altText}"
    >
      <source src="${videoSrc}" type="video/mp4">
    </video>

    <div class="visually-hidden">
      Product video showing item details, features, and usage demonstration.
    </div>

    <div class="multi-image-lens"></div>
  `;
    } else {
      /* Image */
      const newSrc = img.dataset.large || img.src;
      const altText = img.alt || 'Product image';

      wrapper.innerHTML = `
       <img
          src="${newSrc}"
          class="multi-main-image js-multi-main-image"
          alt="${altText}"
          width="800"
          height="800"
          loading="lazy"
          decoding="async"
        >
      <div class="multi-image-lens"></div>
      `;
    }

    bundle.querySelectorAll('.multi-thumb').forEach((el) => {
      el.classList.remove('active');
    });

    thumb.classList.add('active');

    return;
  }

  /* MAIN IMAGE CLICK */

  const mainImg = e.target.closest('.multi-image-wrapper img');

  if (mainImg && !e.target.closest('.multi-zoom-icon')) {
    const bundle = mainImg.closest('.multi-add-cart-left');

    if (!bundle) return;

    const thumbs = bundle.querySelectorAll('.multi-thumb:not(.more-thumb) img');

    let activeIndex = 0;

    thumbs.forEach((img, i) => {
      const large = (img.dataset.large || img.src).split('?')[0];
      const current = mainImg.src.split('?')[0];

      if (current.includes(large)) {
        activeIndex = i;
      }
    });

    openBundleFancybox(bundle, activeIndex);

    return;
  }

  /* ZOOM ICON */

  const zoomIcon = e.target.closest('.multi-zoom-icon');

  if (zoomIcon) {
    e.stopPropagation();

    const wrapper = zoomIcon.closest('.multi-image-wrapper');
    const img = wrapper?.querySelector('.js-multi-main-image');
    const lens = wrapper?.querySelector('.multi-image-lens');

    if (!wrapper || !img || !lens) return;

    wrapper.classList.toggle('zoom-enabled');

    lens.style.backgroundImage = `url(${img.src})`;

    lens.style.display = wrapper.classList.contains('zoom-enabled') ? 'block' : 'none';

    if (wrapper.dataset.zoomInit === 'true') return;

    wrapper.dataset.zoomInit = 'true';

    wrapper.addEventListener('mousemove', function (ev) {
      if (!wrapper.classList.contains('zoom-enabled')) return;

      const rect = img.getBoundingClientRect();

      let x = ev.clientX - rect.left;
      let y = ev.clientY - rect.top;

      const lensW = lens.offsetWidth / 2;
      const lensH = lens.offsetHeight / 2;

      x = Math.max(lensW, Math.min(x, rect.width - lensW));
      y = Math.max(lensH, Math.min(y, rect.height - lensH));

      lens.style.left = x - lensW + 'px';
      lens.style.top = y - lensH + 'px';

      const bgX = (x / rect.width) * 100;
      const bgY = (y / rect.height) * 100;

      lens.style.backgroundPosition = `${bgX}% ${bgY}%`;
    });

    wrapper.addEventListener('mouseenter', function () {
      if (wrapper.classList.contains('zoom-enabled')) {
        lens.style.display = 'block';
      }
    });

    wrapper.addEventListener('mouseleave', function () {
      lens.style.display = 'none';
    });
  }
});

/* =========================================
   FANCYBOX GALLERY
========================================= */

function openBundleFancybox(bundle, startIndex = 0) {
  const images = bundle.querySelectorAll('.multi-thumb:not(.more-thumb) img');

  const items = [];

  if (images.length) {
    images.forEach((img) => {
      items.push({
        src: img.dataset.src || img.dataset.large || img.src,
        type: 'image',
      });
    });
  } else {
    /* No thumbnails (collection has no secondary images): fall back to the
       main image so it can still be zoomed. */
    const mainImg = bundle.querySelector('.js-multi-main-image');

    if (!mainImg) return;

    items.push({
      src: mainImg.dataset.src || mainImg.dataset.large || mainImg.src,
      type: 'image',
    });

    startIndex = 0;
  }

  if (!items.length) return;

  /* global Fancybox */
  Fancybox.show(items, {
    startIndex: startIndex,
    Thumbs: { autoStart: true },
    Toolbar: {
      display: ['zoom', 'slideshow', 'fullscreen', 'thumbs', 'close'],
    },
  });
}

document.addEventListener('input', function (e) {
  if (e.target.classList.contains('qty-input')) {
    // remove non-numeric
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  }
});

document.addEventListener('change', function (e) {
  const input = e.target;

  if (!input.matches('.variant-picker input[type="radio"]')) return;

  const variantId = input.dataset.variantId;
  const item = input.closest('.multi-add-cart-item');
  if (!item || !variantId) return;

  const qtyInput = item.querySelector('.qty-input');

  let variants = [];
  try {
    variants = JSON.parse(item.dataset.variants || '[]');
  } catch {
    console.error('Invalid variants JSON');
    return;
  }

  const selectedVariant = variants.find((v) => String(v.id) === String(variantId));
  if (!selectedVariant) return;

  // ✅ update dataset
  item.setAttribute('data-variant-id', variantId);

  if (qtyInput) {
    qtyInput.setAttribute('data-variant-id', variantId);
    qtyInput.dataset.price = selectedVariant.price;
  }

  // ✅ update UI price
  const priceEl = item.querySelector('[data-price]');
  const compareEl = item.querySelector('[data-compare-price]');

  if (priceEl) {
    priceEl.textContent = formatMoney(selectedVariant.price);
  }

  if (compareEl) {
    if (selectedVariant.compare_at_price > selectedVariant.price) {
      compareEl.textContent = formatMoney(selectedVariant.compare_at_price);
    } else {
      compareEl.textContent = '';
    }
  }
});
